import { scheduleHandler } from './engine.js';
import { createHandler } from './create-handler.js';

const observe = (fn) => {
    const handler = createHandler({ type: 'observeFunction', fn });

    scheduleHandler(handler.notify);
    return () => {
        handler.dispose();
    };
};

export { observe };
